module.exports = __webpack_public_path__ + "img/winerackdog10.9ea40d45.jpg";